import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'SSL Encrypted',
      description: '256-bit encryption'
    },
    {
      icon: 'Lock',
      title: 'Secure Authentication',
      description: 'WhatsApp OTP verification'
    },
    {
      icon: 'Eye',
      title: 'Privacy Protected',
      description: 'No data sharing'
    },
    {
      icon: 'CheckCircle',
      title: 'Verified Platform',
      description: 'Trusted by businesses'
    }
  ];

  return (
    <div className="w-full max-w-4xl mx-auto mt-12">
      <div className="text-center mb-8">
        <h2 className="text-lg font-semibold text-foreground mb-2">
          Enterprise-Grade Security
        </h2>
        <p className="text-sm text-muted-foreground">
          Your business data is protected with industry-standard security measures
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {securityFeatures.map((feature, index) => (
          <div key={index} className="bg-card border border-border rounded-lg p-4 text-center">
            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-3">
              <Icon name={feature.icon} size={20} className="text-[#E3403B]" />
            </div>
            <h3 className="text-sm font-medium text-foreground mb-1">
              {feature.title}
            </h3>
            <p className="text-xs text-muted-foreground">
              {feature.description}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-8 text-center">
        <div className="inline-flex items-center space-x-2 text-xs text-muted-foreground">
          <Icon name="Shield" size={14} />
          <span>SOC 2 Type II Compliant</span>
          <span>•</span>
          <span>GDPR Ready</span>
          <span>•</span>
          <span>ISO 27001 Certified</span>
        </div>
      </div>
    </div>
  );
};

export default SecurityBadges;